import { getTenantContextSnapshot } from './tenantContext'

function storageOrNull(storage) {
	return storage && typeof storage.getItem === 'function' ? storage : null
}

// Browser values which shape a tenant-scoped query are namespaced by the
// validated current Organization. They are never an authority source.
export function organizationStorageKey(key, organizationId = getTenantContextSnapshot().organizationId) {
	const normalizedId = String(organizationId ?? '')
	if (!key || !/^[1-9]\d*$/.test(normalizedId)) return null
	return `reldo:organization:${normalizedId}:${key}`
}

export function readOrganizationStorage(key, storage = globalThis.localStorage) {
	const scopedKey = organizationStorageKey(key)
	return scopedKey && storageOrNull(storage) ? storage.getItem(scopedKey) : null
}

export function writeOrganizationStorage(key, value, storage = globalThis.localStorage) {
	const scopedKey = organizationStorageKey(key)
	if (!scopedKey || !storageOrNull(storage)) return false
	storage.setItem(scopedKey, value)
	return true
}

// Shared legacy values must not be migrated across Organizations.
export function removeLegacyOrganizationStorage(key, storage = globalThis.localStorage) {
	if (storage && typeof storage.removeItem === 'function') storage.removeItem(key)
}
